import CtverecProKresleni from './CtverecProKresleni';

export default class View {
	private platno: HTMLCanvasElement = <HTMLCanvasElement>document.getElementById('platno');
	private kontext: CanvasRenderingContext2D = this.platno.getContext('2d');
	private vykreslit: CtverecProKresleni[];

	constructor(vykreslit: CtverecProKresleni[]) {
		this.vykreslit = vykreslit;
		this.nastavRozmery();
		window.addEventListener('resize', () => {
			this.nastavRozmery();
		});
	}

	private nastavRozmery(): void {
		this.platno.width = window.innerWidth;
		this.platno.height = window.innerHeight;
	}

	kresli(): void {
		for (const ctverec of this.vykreslit) {
			this.kontext.fillStyle = ctverec.barva;
			this.kontext.fillRect(ctverec.x, ctverec.y, ctverec.strana, ctverec.strana);
		}
		this.vykreslit.splice(0, this.vykreslit.length);
		requestAnimationFrame(() => {
			this.kresli();
		});
	}
}
